// @generated by protobuf-ts 2.9.1
// @generated from protobuf file "ui.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { RaidSimResult } from "./api";
import { RaidSimRequest } from "./api";
import { Raid } from "./api";
import { Blessings } from "./paladin";
import { APLRotation } from "./apl";
import { Glyphs } from "./common";
import { HealingModel } from "./common";
import { ItemSwap } from "./common";
import { Race } from "./common";
import { Consumes } from "./common";
import { IndividualBuffs } from "./common";
import { EquipmentSpec } from "./common";
import { Stat } from "./common";
import { UnitStats } from "./common";
import { Encounter } from "./common";
import { Player } from "./api";
import { PartyBuffs } from "./common";
import { UnitReference } from "./common";
import { Debuffs } from "./common";
import { RaidBuffs } from "./common";
import { EnchantType } from "./common";
import { Faction } from "./common";
import { Profession } from "./common";
import { Class } from "./common";
import { ItemQuality } from "./common";
import { GemColor } from "./common";
import { RangedWeaponType } from "./common";
import { HandType } from "./common";
import { WeaponType } from "./common";
import { ArmorType } from "./common";
import { ItemType } from "./common";
import { PresetEncounter } from "./common";
/**
 * Holds all WoW data for the UI.
 *
 * @generated from protobuf message proto.UIDatabase
 */
export interface UIDatabase {
    /**
     * @generated from protobuf field: repeated proto.UIItem items = 1;
     */
    items: UIItem[];
    /**
     * @generated from protobuf field: repeated proto.UIEnchant enchants = 2;
     */
    enchants: UIEnchant[];
    /**
     * @generated from protobuf field: repeated proto.UIGem gems = 3;
     */
    gems: UIGem[];
    /**
     * @generated from protobuf field: repeated proto.PresetEncounter encounters = 6;
     */
    encounters: PresetEncounter[];
    /**
     * @generated from protobuf field: repeated proto.UIZone zones = 8;
     */
    zones: UIZone[];
    /**
     * @generated from protobuf field: repeated proto.UINPC npcs = 9;
     */
    npcs: UINPC[];
    /**
     * Entities for which we just need a name/icon.
     *
     * @generated from protobuf field: repeated proto.IconData item_icons = 4;
     */
    itemIcons: IconData[];
    /**
     * @generated from protobuf field: repeated proto.IconData spell_icons = 5;
     */
    spellIcons: IconData[];
    /**
     * @generated from protobuf field: repeated proto.GlyphID glyph_ids = 7;
     */
    glyphIds: GlyphID[];
}
/**
 * @generated from protobuf message proto.UIZone
 */
export interface UIZone {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: proto.Expansion expansion = 3;
     */
    expansion: Expansion;
}
/**
 * @generated from protobuf message proto.UINPC
 */
export interface UINPC {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 zone_id = 3;
     */
    zoneId: number;
}
/**
 * Contains all information about an Item needed by the UI.
 * Generally this will include everything needed by the sim, plus some
 * additional data for displaying / filtering.
 * Next tag: 26.
 *
 * @generated from protobuf message proto.UIItem
 */
export interface UIItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string icon = 3;
     */
    icon: string;
    /**
     * @generated from protobuf field: proto.ItemType type = 4;
     */
    type: ItemType;
    /**
     * @generated from protobuf field: proto.ArmorType armor_type = 5;
     */
    armorType: ArmorType;
    /**
     * @generated from protobuf field: proto.WeaponType weapon_type = 6;
     */
    weaponType: WeaponType;
    /**
     * @generated from protobuf field: proto.HandType hand_type = 7;
     */
    handType: HandType;
    /**
     * @generated from protobuf field: proto.RangedWeaponType ranged_weapon_type = 8;
     */
    rangedWeaponType: RangedWeaponType;
    /**
     * @generated from protobuf field: repeated double stats = 9;
     */
    stats: number[];
    /**
     * @generated from protobuf field: repeated proto.GemColor gem_sockets = 10;
     */
    gemSockets: GemColor[];
    /**
     * @generated from protobuf field: repeated double socketBonus = 11;
     */
    socketBonus: number[];
    /**
     * Weapon stats, needed for computing proper EP for melee weapons
     *
     * @generated from protobuf field: double weapon_damage_min = 12;
     */
    weaponDamageMin: number;
    /**
     * @generated from protobuf field: double weapon_damage_max = 13;
     */
    weaponDamageMax: number;
    /**
     * @generated from protobuf field: double weapon_speed = 14;
     */
    weaponSpeed: number;
    /**
     * @generated from protobuf field: int32 ilvl = 15;
     */
    ilvl: number;
    /**
     * @generated from protobuf field: int32 phase = 16;
     */
    phase: number;
    /**
     * @generated from protobuf field: proto.ItemQuality quality = 17;
     */
    quality: ItemQuality;
    /**
     * @generated from protobuf field: bool unique = 18;
     */
    unique: boolean;
    /**
     * @generated from protobuf field: bool heroic = 19;
     */
    heroic: boolean;
    /**
     * Classes that are allowed to use the item. Empty indicates no special class restrictions.
     *
     * @generated from protobuf field: repeated proto.Class class_allowlist = 20;
     */
    classAllowlist: Class[];
    /**
     * @generated from protobuf field: proto.Profession required_profession = 21;
     */
    requiredProfession: Profession;
    /**
     * Name of the item set to which this item belongs, if any.
     *
     * @generated from protobuf field: string set_name = 22;
     */
    setName: string;
    /**
     * @generated from protobuf field: proto.Expansion expansion = 24;
     */
    expansion: Expansion;
    /**
     * @generated from protobuf field: repeated proto.UIItemSource sources = 23;
     */
    sources: UIItemSource[];
    /**
     * @generated from protobuf field: proto.UIItem.FactionRestriction faction_restriction = 25;
     */
    factionRestriction: UIItem_FactionRestriction;
}
/**
 * @generated from protobuf enum proto.UIItem.FactionRestriction
 */
export enum UIItem_FactionRestriction {
    /**
     * @generated from protobuf enum value: FACTION_RESTRICTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FACTION_RESTRICTION_ALLIANCE_ONLY = 1;
     */
    ALLIANCE_ONLY = 1,
    /**
     * @generated from protobuf enum value: FACTION_RESTRICTION_HORDE_ONLY = 2;
     */
    HORDE_ONLY = 2
}
/**
 * @generated from protobuf message proto.UIItemSource
 */
export interface UIItemSource {
    /**
     * @generated from protobuf oneof: source
     */
    source: {
        oneofKind: "crafted";
        /**
         * @generated from protobuf field: proto.CraftedSource crafted = 1;
         */
        crafted: CraftedSource;
    } | {
        oneofKind: "drop";
        /**
         * @generated from protobuf field: proto.DropSource drop = 2;
         */
        drop: DropSource;
    } | {
        oneofKind: "quest";
        /**
         * @generated from protobuf field: proto.QuestSource quest = 3;
         */
        quest: QuestSource;
    } | {
        oneofKind: "soldBy";
        /**
         * @generated from protobuf field: proto.SoldBySource sold_by = 4;
         */
        soldBy: SoldBySource;
    } | {
        oneofKind: "rep";
        /**
         * @generated from protobuf field: proto.RepSource rep = 5;
         */
        rep: RepSource;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message proto.CraftedSource
 */
export interface CraftedSource {
    /**
     * @generated from protobuf field: proto.Profession profession = 1;
     */
    profession: Profession;
    /**
     * @generated from protobuf field: int32 spell_id = 2;
     */
    spellId: number;
}
/**
 * @generated from protobuf message proto.DropSource
 */
export interface DropSource {
    /**
     * @generated from protobuf field: proto.DungeonDifficulty difficulty = 1;
     */
    difficulty: DungeonDifficulty;
    /**
     * @generated from protobuf field: int32 npc_id = 2;
     */
    npcId: number;
    /**
     * @generated from protobuf field: int32 zone_id = 3;
     */
    zoneId: number;
    /**
     * @generated from protobuf field: string other_name = 4;
     */
    otherName: string; // For drops in zones from things other than NPCs, e.g. "Trash"
    /**
     * @generated from protobuf field: string category = 5;
     */
    category: string; // For conditions/categories of drops, e.g. 'Hard Mode' or 'Titan Rune'
}
/**
 * @generated from protobuf message proto.QuestSource
 */
export interface QuestSource {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message proto.SoldBySource
 */
export interface SoldBySource {
    /**
     * @generated from protobuf field: int32 npc_id = 1;
     */
    npcId: number;
    /**
     * @generated from protobuf field: string npc_name = 2;
     */
    npcName: string;
    /**
     * @generated from protobuf field: int32 zone_id = 3;
     */
    zoneId: number;
}
/**
 * @generated from protobuf message proto.RepSource
 */
export interface RepSource {
    /**
     * @generated from protobuf field: proto.RepFaction rep_faction_id = 1;
     */
    repFactionId: RepFaction;
    /**
     * @generated from protobuf field: proto.RepLevel rep_level = 2;
     */
    repLevel: RepLevel;
    /**
     * @generated from protobuf field: proto.Faction faction_id = 3;
     */
    factionId: Faction;
}
/**
 * @generated from protobuf message proto.UIEnchant
 */
export interface UIEnchant {
    /**
     * All enchants have an effect ID. Some also have an item ID, others have a spell ID,
     * and yet others have both item and spell IDs. No single ID alone is enough to
     * uniquely identify an enchant. Uniqueness requires either effect ID + slot, or
     * effect ID + item/spell ID.
     *
     * @generated from protobuf field: int32 effect_id = 1;
     */
    effectId: number; // ID of the effect.
    /**
     * @generated from protobuf field: int32 item_id = 2;
     */
    itemId: number; // ID of the enchant "item". Might be 0 if not available.
    /**
     * @generated from protobuf field: int32 spell_id = 3;
     */
    spellId: number; // ID of the enchant "spell". Might be 0 if not available.
    /**
     * @generated from protobuf field: string name = 4;
     */
    name: string;
    /**
     * @generated from protobuf field: string icon = 5;
     */
    icon: string;
    /**
     * @generated from protobuf field: proto.ItemType type = 6;
     */
    type: ItemType; // Which type of item this enchant can be applied to.
    /**
     * @generated from protobuf field: repeated proto.ItemType extra_types = 13;
     */
    extraTypes: ItemType[]; // Extra types for enchants that can go in multiple slots (like armor kits).
    /**
     * @generated from protobuf field: proto.EnchantType enchant_type = 7;
     */
    enchantType: EnchantType;
    /**
     * @generated from protobuf field: repeated double stats = 8;
     */
    stats: number[];
    /**
     * @generated from protobuf field: proto.ItemQuality quality = 9;
     */
    quality: ItemQuality;
    /**
     * @generated from protobuf field: int32 phase = 10;
     */
    phase: number;
    /**
     * Classes that are allowed to use the enchant. Empty indicates no special class restrictions.
     *
     * @generated from protobuf field: repeated proto.Class class_allowlist = 11;
     */
    classAllowlist: Class[];
    /**
     * @generated from protobuf field: proto.Profession required_profession = 12;
     */
    requiredProfession: Profession;
}
/**
 * @generated from protobuf message proto.UIGem
 */
export interface UIGem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string icon = 3;
     */
    icon: string;
    /**
     * @generated from protobuf field: proto.GemColor color = 4;
     */
    color: GemColor;
    /**
     * @generated from protobuf field: repeated double stats = 5;
     */
    stats: number[];
    /**
     * @generated from protobuf field: int32 phase = 6;
     */
    phase: number;
    /**
     * @generated from protobuf field: proto.ItemQuality quality = 7;
     */
    quality: ItemQuality;
    /**
     * @generated from protobuf field: bool unique = 8;
     */
    unique: boolean;
    /**
     * @generated from protobuf field: proto.Profession required_profession = 9;
     */
    requiredProfession: Profession;
}
/**
 * @generated from protobuf message proto.IconData
 */
export interface IconData {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string icon = 3;
     */
    icon: string;
}
/**
 * @generated from protobuf message proto.GlyphID
 */
export interface GlyphID {
    /**
     * @generated from protobuf field: int32 item_id = 1;
     */
    itemId: number;
    /**
     * @generated from protobuf field: int32 spell_id = 2;
     */
    spellId: number;
}
/**
 * Next tag: 20.
 *
 * @generated from protobuf message proto.DatabaseFilters
 */
export interface DatabaseFilters {
    /**
     * @generated from protobuf field: repeated proto.ArmorType armor_types = 1;
     */
    armorTypes: ArmorType[];
    /**
     * @generated from protobuf field: repeated proto.WeaponType weapon_types = 2;
     */
    weaponTypes: WeaponType[];
    /**
     * @generated from protobuf field: repeated proto.RangedWeaponType ranged_weapon_types = 16;
     */
    rangedWeaponTypes: RangedWeaponType[];
    /**
     * @generated from protobuf field: repeated proto.SourceFilterOption sources = 17;
     */
    sources: SourceFilterOption[];
    /**
     * @generated from protobuf field: repeated proto.RaidFilterOption raids = 18;
     */
    raids: RaidFilterOption[];
    /**
     * @generated from protobuf field: proto.UIItem.FactionRestriction faction_restriction = 19;
     */
    factionRestriction: UIItem_FactionRestriction;
    /**
     * @generated from protobuf field: double min_mh_weapon_speed = 4;
     */
    minMhWeaponSpeed: number;
    /**
     * @generated from protobuf field: double max_mh_weapon_speed = 5;
     */
    maxMhWeaponSpeed: number;
    /**
     * @generated from protobuf field: double min_oh_weapon_speed = 9;
     */
    minOhWeaponSpeed: number;
    /**
     * @generated from protobuf field: double max_oh_weapon_speed = 10;
     */
    maxOhWeaponSpeed: number;
    /**
     * @generated from protobuf field: double min_ranged_weapon_speed = 14;
     */
    minRangedWeaponSpeed: number;
    /**
     * @generated from protobuf field: double max_ranged_weapon_speed = 15;
     */
    maxRangedWeaponSpeed: number;
    /**
     * @generated from protobuf field: bool one_handed_weapons = 6;
     */
    oneHandedWeapons: boolean;
    /**
     * @generated from protobuf field: bool two_handed_weapons = 7;
     */
    twoHandedWeapons: boolean;
    /**
     * @generated from protobuf field: bool matching_gems_only = 8;
     */
    matchingGemsOnly: boolean;
    /**
     * Item IDs for favorited items.
     *
     * @generated from protobuf field: repeated int32 favorite_items = 11;
     */
    favoriteItems: number[];
    /**
     * Item IDs for favorited gems.
     *
     * @generated from protobuf field: repeated int32 favorite_gems = 12;
     */
    favoriteGems: number[];
    /**
     * Uniquely-identifying strings for favorited enchants.
     *
     * @generated from protobuf field: repeated string favorite_enchants = 13;
     */
    favoriteEnchants: string[];
}
/**
 * @generated from protobuf message proto.SimSettings
 */
export interface SimSettings {
    /**
     * @generated from protobuf field: int32 iterations = 1;
     */
    iterations: number;
    /**
     * @generated from protobuf field: int32 phase = 2;
     */
    phase: number;
    /**
     * @generated from protobuf field: int64 fixed_rng_seed = 3;
     */
    fixedRngSeed: bigint;
    /**
     * @generated from protobuf field: bool show_damage_metrics = 8;
     */
    showDamageMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_threat_metrics = 4;
     */
    showThreatMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_healing_metrics = 7;
     */
    showHealingMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_experimental = 5;
     */
    showExperimental: boolean;
    /**
     * @generated from protobuf field: bool show_ep_values = 11;
     */
    showEpValues: boolean;
    /**
     * @generated from protobuf field: string language = 9;
     */
    language: string;
    /**
     * @generated from protobuf field: proto.Faction faction = 6;
     */
    faction: Faction;
    /**
     * @generated from protobuf field: proto.DatabaseFilters filters = 10;
     */
    filters?: DatabaseFilters;
}
/**
 * Contains all information that is imported/exported from an individual sim.
 *
 * @generated from protobuf message proto.IndividualSimSettings
 */
export interface IndividualSimSettings {
    /**
     * @generated from protobuf field: proto.SimSettings settings = 5;
     */
    settings?: SimSettings;
    /**
     * @generated from protobuf field: proto.RaidBuffs raid_buffs = 1;
     */
    raidBuffs?: RaidBuffs;
    /**
     * @generated from protobuf field: proto.Debuffs debuffs = 8;
     */
    debuffs?: Debuffs;
    /**
     * @generated from protobuf field: repeated proto.UnitReference tanks = 7;
     */
    tanks: UnitReference[];
    /**
     * @generated from protobuf field: proto.PartyBuffs party_buffs = 2;
     */
    partyBuffs?: PartyBuffs;
    /**
     * @generated from protobuf field: proto.Player player = 3;
     */
    player?: Player;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 4;
     */
    encounter?: Encounter;
    /**
     * @generated from protobuf field: int32 target_dummies = 9;
     */
    targetDummies: number;
    /**
     * @generated from protobuf field: proto.UnitStats ep_weights_stats = 10;
     */
    epWeightsStats?: UnitStats;
    /**
     * @generated from protobuf field: repeated double ep_ratios = 11;
     */
    epRatios: number[];
    /**
     * @generated from protobuf field: proto.Stat dps_ref_stat = 12;
     */
    dpsRefStat: Stat;
    /**
     * @generated from protobuf field: proto.Stat heal_ref_stat = 13;
     */
    healRefStat: Stat;
    /**
     * @generated from protobuf field: proto.Stat tank_ref_stat = 14;
     */
    tankRefStat: Stat;
}
/**
 * Local storage data for gear settings.
 *
 * @generated from protobuf message proto.SavedGearSet
 */
export interface SavedGearSet {
    /**
     * @generated from protobuf field: proto.EquipmentSpec gear = 1;
     */
    gear?: EquipmentSpec;
    /**
     * @generated from protobuf field: proto.UnitStats bonus_stats_stats = 3;
     */
    bonusStatsStats?: UnitStats;
}
/**
 * Local storage data for other settings.
 *
 * @generated from protobuf message proto.SavedSettings
 */
export interface SavedSettings {
    /**
     * @generated from protobuf field: proto.RaidBuffs raid_buffs = 1;
     */
    raidBuffs?: RaidBuffs;
    /**
     * @generated from protobuf field: proto.PartyBuffs party_buffs = 2;
     */
    partyBuffs?: PartyBuffs;
    /**
     * @generated from protobuf field: proto.Debuffs debuffs = 7;
     */
    debuffs?: Debuffs;
    /**
     * @generated from protobuf field: proto.IndividualBuffs player_buffs = 3;
     */
    playerBuffs?: IndividualBuffs;
    /**
     * @generated from protobuf field: proto.Consumes consumes = 4;
     */
    consumes?: Consumes;
    /**
     * @generated from protobuf field: proto.Race race = 5;
     */
    race: Race;
    /**
     * @generated from protobuf field: repeated proto.Profession professions = 9;
     */
    professions: Profession[];
    /**
     * @generated from protobuf field: bool enable_item_swap = 18;
     */
    enableItemSwap: boolean;
    /**
     * @generated from protobuf field: proto.ItemSwap item_swap = 17;
     */
    itemSwap?: ItemSwap;
    /**
     * @generated from protobuf field: int32 reaction_time_ms = 10;
     */
    reactionTimeMs: number;
    /**
     * @generated from protobuf field: int32 channel_clip_delay_ms = 14;
     */
    channelClipDelayMs: number;
    /**
     * @generated from protobuf field: bool in_front_of_target = 11;
     */
    inFrontOfTarget: boolean;
    /**
     * @generated from protobuf field: double distance_from_target = 12;
     */
    distanceFromTarget: number;
    /**
     * @generated from protobuf field: proto.HealingModel healing_model = 13;
     */
    healingModel?: HealingModel;
    /**
     * @generated from protobuf field: double nibelung_average_casts = 15;
     */
    nibelungAverageCasts: number;
    /**
     * hack to set a proper default value
     *
     * @generated from protobuf field: bool nibelung_average_casts_set = 16;
     */
    nibelungAverageCastsSet: boolean;
}
/**
 * @generated from protobuf message proto.SavedTalents
 */
export interface SavedTalents {
    /**
     * @generated from protobuf field: string talents_string = 1;
     */
    talentsString: string;
    /**
     * @generated from protobuf field: proto.Glyphs glyphs = 2;
     */
    glyphs?: Glyphs;
}
/**
 * @generated from protobuf message proto.SavedRotation
 */
export interface SavedRotation {
    /**
     * @generated from protobuf field: proto.APLRotation rotation = 1;
     */
    rotation?: APLRotation;
}
/**
 * @generated from protobuf message proto.BlessingsAssignment
 */
export interface BlessingsAssignment {
    /**
     * Index corresponds to Spec that the blessing should be applied to.
     *
     * @generated from protobuf field: repeated proto.Blessings blessings = 1;
     */
    blessings: Blessings[];
}
/**
 * @generated from protobuf message proto.BlessingsAssignments
 */
export interface BlessingsAssignments {
    /**
     * Assignments for each paladin.
     *
     * @generated from protobuf field: repeated proto.BlessingsAssignment paladins = 1;
     */
    paladins: BlessingsAssignment[];
}
/**
 * Local storage data for a saved encounter.
 *
 * @generated from protobuf message proto.SavedEncounter
 */
export interface SavedEncounter {
    /**
     * @generated from protobuf field: proto.Encounter encounter = 1;
     */
    encounter?: Encounter;
}
/**
 * Local storage data for raid sim settings.
 *
 * @generated from protobuf message proto.SavedRaid
 */
export interface SavedRaid {
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: proto.BlessingsAssignments blessings = 3;
     */
    blessings?: BlessingsAssignments;
    /**
     * @generated from protobuf field: proto.Faction faction = 4;
     */
    faction: Faction;
    /**
     * @generated from protobuf field: int32 phase = 5;
     */
    phase: number;
}
/**
 * Contains all information that is imported/exported from a raid sim.
 *
 * @generated from protobuf message proto.RaidSimSettings
 */
export interface RaidSimSettings {
    /**
     * @generated from protobuf field: proto.SimSettings settings = 5;
     */
    settings?: SimSettings;
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: proto.BlessingsAssignments blessings = 3;
     */
    blessings?: BlessingsAssignments;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 4;
     */
    encounter?: Encounter;
}
/**
 * All the data related to running the sim once.
 *
 * @generated from protobuf message proto.SimRun
 */
export interface SimRun {
    /**
     * @generated from protobuf field: proto.RaidSimRequest request = 1;
     */
    request?: RaidSimRequest;
    /**
     * @generated from protobuf field: proto.RaidSimResult result = 2;
     */
    result?: RaidSimResult;
}
/**
 * Contains a sim run and also other context data.
 *
 * @generated from protobuf message proto.SimRunData
 */
export interface SimRunData {
    /**
     * @generated from protobuf field: proto.SimRun run = 1;
     */
    run?: SimRun;
    /**
     * The run stored as a reference, for comparison to the current run.
     *
     * @generated from protobuf field: proto.SimRun reference_run = 2;
     */
    referenceRun?: SimRun;
}
/**
 * Sent by the sim to the detailed results page.
 *
 * @generated from protobuf message proto.DetailedResultsUpdate
 */
export interface DetailedResultsUpdate {
    /**
     * @generated from protobuf oneof: data
     */
    data: {
        oneofKind: "runData";
        /**
         * Show results from a run.
         *
         * @generated from protobuf field: proto.SimRunData run_data = 1;
         */
        runData: SimRunData;
    } | {
        oneofKind: "settings";
        /**
         * Update sim settings.
         *
         * @generated from protobuf field: proto.SimSettings settings = 2;
         */
        settings: SimSettings;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum proto.Expansion
 */
export enum Expansion {
    /**
     * @generated from protobuf enum value: ExpansionUnknown = 0;
     */
    ExpansionUnknown = 0,
    /**
     * @generated from protobuf enum value: ExpansionVanilla = 1;
     */
    ExpansionVanilla = 1,
    /**
     * @generated from protobuf enum value: ExpansionTbc = 2;
     */
    ExpansionTbc = 2,
    /**
     * @generated from protobuf enum value: ExpansionWotlk = 3;
     */
    ExpansionWotlk = 3
}
/**
 * @generated from protobuf enum proto.DungeonDifficulty
 */
export enum DungeonDifficulty {
    /**
     * @generated from protobuf enum value: DifficultyUnknown = 0;
     */
    DifficultyUnknown = 0,
    /**
     * @generated from protobuf enum value: DifficultyNormal = 1;
     */
    DifficultyNormal = 1,
    /**
     * @generated from protobuf enum value: DifficultyHeroic = 2;
     */
    DifficultyHeroic = 2,
    /**
     * @generated from protobuf enum value: DifficultyTitanRuneAlpha = 7;
     */
    DifficultyTitanRuneAlpha = 7,
    /**
     * @generated from protobuf enum value: DifficultyTitanRuneBeta = 8;
     */
    DifficultyTitanRuneBeta = 8,
    /**
     * @generated from protobuf enum value: DifficultyRaid10 = 3;
     */
    DifficultyRaid10 = 3,
    /**
     * @generated from protobuf enum value: DifficultyRaid10H = 4;
     */
    DifficultyRaid10H = 4,
    /**
     * @generated from protobuf enum value: DifficultyRaid25 = 5;
     */
    DifficultyRaid25 = 5,
    /**
     * @generated from protobuf enum value: DifficultyRaid25H = 6;
     */
    DifficultyRaid25H = 6
}
/**
 * @generated from protobuf enum proto.RepLevel
 */
export enum RepLevel {
    /**
     * @generated from protobuf enum value: RepLevelUnknown = 0;
     */
    RepLevelUnknown = 0,
    /**
     * @generated from protobuf enum value: RepLevelHated = 1;
     */
    RepLevelHated = 1,
    /**
     * @generated from protobuf enum value: RepLevelHostile = 2;
     */
    RepLevelHostile = 2,
    /**
     * @generated from protobuf enum value: RepLevelUnfriendly = 3;
     */
    RepLevelUnfriendly = 3,
    /**
     * @generated from protobuf enum value: RepLevelNeutral = 4;
     */
    RepLevelNeutral = 4,
    /**
     * @generated from protobuf enum value: RepLevelFriendly = 5;
     */
    RepLevelFriendly = 5,
    /**
     * @generated from protobuf enum value: RepLevelHonored = 6;
     */
    RepLevelHonored = 6,
    /**
     * @generated from protobuf enum value: RepLevelRevered = 7;
     */
    RepLevelRevered = 7,
    /**
     * @generated from protobuf enum value: RepLevelExalted = 8;
     */
    RepLevelExalted = 8
}
/**
 * TODO: Wotlk Rep Factions
 * Use the faction ID for the field index
 *
 * @generated from protobuf enum proto.RepFaction
 */
export enum RepFaction {
    /**
     * @generated from protobuf enum value: RepFactionUnknown = 0;
     */
    RepFactionUnknown = 0
}
/**
 * @generated from protobuf enum proto.SourceFilterOption
 */
export enum SourceFilterOption {
    /**
     * @generated from protobuf enum value: SourceUnknown = 0;
     */
    SourceUnknown = 0,
    /**
     * @generated from protobuf enum value: SourceCrafting = 1;
     */
    SourceCrafting = 1,
    /**
     * @generated from protobuf enum value: SourceQuest = 2;
     */
    SourceQuest = 2,
    /**
     * @generated from protobuf enum value: SourceDungeon = 3;
     */
    SourceDungeon = 3,
    /**
     * @generated from protobuf enum value: SourceDungeonH = 4;
     */
    SourceDungeonH = 4,
    /**
     * @generated from protobuf enum value: SourceDungeonTRA = 9;
     */
    SourceDungeonTRA = 9,
    /**
     * @generated from protobuf enum value: SourceDungeonTRB = 10;
     */
    SourceDungeonTRB = 10,
    /**
     * @generated from protobuf enum value: SourceRaid10 = 5;
     */
    SourceRaid10 = 5,
    /**
     * @generated from protobuf enum value: SourceRaid10H = 6;
     */
    SourceRaid10H = 6,
    /**
     * @generated from protobuf enum value: SourceRaid25 = 7;
     */
    SourceRaid25 = 7,
    /**
     * @generated from protobuf enum value: SourceRaid25H = 8;
     */
    SourceRaid25H = 8
}
/**
 * @generated from protobuf enum proto.RaidFilterOption
 */
export enum RaidFilterOption {
    /**
     * @generated from protobuf enum value: RaidUnknown = 0;
     */
    RaidUnknown = 0,
    /**
     * @generated from protobuf enum value: RaidVanilla = 1;
     */
    RaidVanilla = 1,
    /**
     * @generated from protobuf enum value: RaidTbc = 2;
     */
    RaidTbc = 2,
    /**
     * @generated from protobuf enum value: RaidNaxxramas = 3;
     */
    RaidNaxxramas = 3,
    /**
     * @generated from protobuf enum value: RaidEyeOfEternity = 4;
     */
    RaidEyeOfEternity = 4,
    /**
     * @generated from protobuf enum value: RaidObsidianSanctum = 5;
     */
    RaidObsidianSanctum = 5,
    /**
     * @generated from protobuf enum value: RaidVaultOfArchavon = 6;
     */
    RaidVaultOfArchavon = 6,
    /**
     * @generated from protobuf enum value: RaidUlduar = 7;
     */
    RaidUlduar = 7,
    /**
     * @generated from protobuf enum value: RaidTrialOfTheCrusader = 8;
     */
    RaidTrialOfTheCrusader = 8,
    /**
     * @generated from protobuf enum value: RaidOnyxiasLair = 9;
     */
    RaidOnyxiasLair = 9,
    /**
     * @generated from protobuf enum value: RaidIcecrownCitadel = 10;
     */
    RaidIcecrownCitadel = 10,
    /**
     * @generated from protobuf enum value: RaidRubySanctum = 11;
     */
    RaidRubySanctum = 11
}
// @generated message type with reflection information, may provide speed optimized methods
class UIDatabase$Type extends MessageType<UIDatabase> {
    constructor() {
        super("proto.UIDatabase", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UIItem },
            { no: 2, name: "enchants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UIEnchant },
            { no: 3, name: "gems", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UIGem },
            { no: 6, name: "encounters", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PresetEncounter },
            { no: 8, name: "zones", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UIZone },
            { no: 9, name: "npcs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UINPC },
            { no: 4, name: "item_icons", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IconData },
            { no: 5, name: "spell_icons", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IconData },
            { no: 7, name: "glyph_ids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GlyphID }
        ]);
    }
    create(value?: PartialMessage<UIDatabase>): UIDatabase {
        const message = { items: [], enchants: [], gems: [], encounters: [], zones: [], npcs: [], itemIcons: [], spellIcons: [], glyphIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIDatabase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIDatabase): UIDatabase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.UIItem items */ 1:
                    message.items.push(UIItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.UIEnchant enchants */ 2:
                    message.enchants.push(UIEnchant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.UIGem gems */ 3:
                    message.gems.push(UIGem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.PresetEncounter encounters */ 6:
                    message.encounters.push(PresetEncounter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.UIZone zones */ 8:
                    message.zones.push(UIZone.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.UINPC npcs */ 9:
                    message.npcs.push(UINPC.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.IconData item_icons */ 4:
                    message.itemIcons.push(IconData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.IconData spell_icons */ 5:
                    message.spellIcons.push(IconData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.GlyphID glyph_ids */ 7:
                    message.glyphIds.push(GlyphID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIDatabase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.UIItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            UIItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UIEnchant enchants = 2; */
        for (let i = 0; i < message.enchants.length; i++)
            UIEnchant.internalBinaryWrite(message.enchants[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UIGem gems = 3; */
        for (let i = 0; i < message.gems.length; i++)
            UIGem.internalBinaryWrite(message.gems[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.PresetEncounter encounters = 6; */
        for (let i = 0; i < message.encounters.length; i++)
            PresetEncounter.internalBinaryWrite(message.encounters[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UIZone zones = 8; */
        for (let i = 0; i < message.zones.length; i++)
            UIZone.internalBinaryWrite(message.zones[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UINPC npcs = 9; */
        for (let i = 0; i < message.npcs.length; i++)
            UINPC.internalBinaryWrite(message.npcs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.IconData item_icons = 4; */
        for (let i = 0; i < message.itemIcons.length; i++)
            IconData.internalBinaryWrite(message.itemIcons[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.IconData spell_icons = 5; */
        for (let i = 0; i < message.spellIcons.length; i++)
            IconData.internalBinaryWrite(message.spellIcons[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.GlyphID glyph_ids = 7; */
        for (let i = 0; i < message.glyphIds.length; i++)
            GlyphID.internalBinaryWrite(message.glyphIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIDatabase
 */
export const UIDatabase = new UIDatabase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIZone$Type extends MessageType<UIZone> {
    constructor() {
        super("proto.UIZone", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expansion", kind: "enum", T: () => ["proto.Expansion", Expansion] }
        ]);
    }
    create(value?: PartialMessage<UIZone>): UIZone {
        const message = { id: 0, name: "", expansion: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIZone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIZone): UIZone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* proto.Expansion expansion */ 3:
                    message.expansion = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIZone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* proto.Expansion expansion = 3; */
        if (message.expansion !== 0)
            writer.tag(3, WireType.Varint).int32(message.expansion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIZone
 */
export const UIZone = new UIZone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UINPC$Type extends MessageType<UINPC> {
    constructor() {
        super("proto.UINPC", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "zone_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<UINPC>): UINPC {
        const message = { id: 0, name: "", zoneId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UINPC>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UINPC): UINPC {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 zone_id */ 3:
                    message.zoneId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UINPC, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 zone_id = 3; */
        if (message.zoneId !== 0)
            writer.tag(3, WireType.Varint).int32(message.zoneId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UINPC
 */
export const UINPC = new UINPC$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIItem$Type extends MessageType<UIItem> {
    constructor() {
        super("proto.UIItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "icon", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["proto.ItemType", ItemType] },
            { no: 5, name: "armor_type", kind: "enum", T: () => ["proto.ArmorType", ArmorType] },
            { no: 6, name: "weapon_type", kind: "enum", T: () => ["proto.WeaponType", WeaponType] },
            { no: 7, name: "hand_type", kind: "enum", T: () => ["proto.HandType", HandType] },
            { no: 8, name: "ranged_weapon_type", kind: "enum", T: () => ["proto.RangedWeaponType", RangedWeaponType] },
            { no: 9, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "gem_sockets", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.GemColor", GemColor] },
            { no: 11, name: "socketBonus", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "weapon_damage_min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "weapon_damage_max", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "ilvl", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "quality", kind: "enum", T: () => ["proto.ItemQuality", ItemQuality] },
            { no: 18, name: "unique", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "heroic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "class_allowlist", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Class", Class] },
            { no: 21, name: "required_profession", kind: "enum", T: () => ["proto.Profession", Profession] },
            { no: 22, name: "set_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "expansion", kind: "enum", T: () => ["proto.Expansion", Expansion] },
            { no: 23, name: "sources", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UIItemSource },
            { no: 25, name: "faction_restriction", kind: "enum", T: () => ["proto.UIItem.FactionRestriction", UIItem_FactionRestriction, "FACTION_RESTRICTION_"] }
        ]);
    }
    create(value?: PartialMessage<UIItem>): UIItem {
        const message = { id: 0, name: "", icon: "", type: 0, armorType: 0, weaponType: 0, handType: 0, rangedWeaponType: 0, stats: [], gemSockets: [], socketBonus: [], weaponDamageMin: 0, weaponDamageMax: 0, weaponSpeed: 0, ilvl: 0, phase: 0, quality: 0, unique: false, heroic: false, classAllowlist: [], requiredProfession: 0, setName: "", expansion: 0, sources: [], factionRestriction: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIItem): UIItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string icon */ 3:
                    message.icon = reader.string();
                    break;
                case /* proto.ItemType type */ 4:
                    message.type = reader.int32();
                    break;
                case /* proto.ArmorType armor_type */ 5:
                    message.armorType = reader.int32();
                    break;
                case /* proto.WeaponType weapon_type */ 6:
                    message.weaponType = reader.int32();
                    break;
                case /* proto.HandType hand_type */ 7:
                    message.handType = reader.int32();
                    break;
                case /* proto.RangedWeaponType ranged_weapon_type */ 8:
                    message.rangedWeaponType = reader.int32();
                    break;
                case /* repeated double stats */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* repeated proto.GemColor gem_sockets */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.gemSockets.push(reader.int32());
                    else
                        message.gemSockets.push(reader.int32());
                    break;
                case /* repeated double socketBonus */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.socketBonus.push(reader.double());
                    else
                        message.socketBonus.push(reader.double());
                    break;
                case /* double weapon_damage_min */ 12:
                    message.weaponDamageMin = reader.double();
                    break;
                case /* double weapon_damage_max */ 13:
                    message.weaponDamageMax = reader.double();
                    break;
                case /* double weapon_speed */ 14:
                    message.weaponSpeed = reader.double();
                    break;
                case /* int32 ilvl */ 15:
                    message.ilvl = reader.int32();
                    break;
                case /* int32 phase */ 16:
                    message.phase = reader.int32();
                    break;
                case /* proto.ItemQuality quality */ 17:
                    message.quality = reader.int32();
                    break;
                case /* bool unique */ 18:
                    message.unique = reader.bool();
                    break;
                case /* bool heroic */ 19:
                    message.heroic = reader.bool();
                    break;
                case /* repeated proto.Class class_allowlist */ 20:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.classAllowlist.push(reader.int32());
                    else
                        message.classAllowlist.push(reader.int32());
                    break;
                case /* proto.Profession required_profession */ 21:
                    message.requiredProfession = reader.int32();
                    break;
                case /* string set_name */ 22:
                    message.setName = reader.string();
                    break;
                case /* proto.Expansion expansion */ 24:
                    message.expansion = reader.int32();
                    break;
                case /* repeated proto.UIItemSource sources */ 23:
                    message.sources.push(UIItemSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.UIItem.FactionRestriction faction_restriction */ 25:
                    message.factionRestriction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string icon = 3; */
        if (message.icon !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.icon);
        /* proto.ItemType type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        /* proto.ArmorType armor_type = 5; */
        if (message.armorType !== 0)
            writer.tag(5, WireType.Varint).int32(message.armorType);
        /* proto.WeaponType weapon_type = 6; */
        if (message.weaponType !== 0)
            writer.tag(6, WireType.Varint).int32(message.weaponType);
        /* proto.HandType hand_type = 7; */
        if (message.handType !== 0)
            writer.tag(7, WireType.Varint).int32(message.handType);
        /* proto.RangedWeaponType ranged_weapon_type = 8; */
        if (message.rangedWeaponType !== 0)
            writer.tag(8, WireType.Varint).int32(message.rangedWeaponType);
        /* repeated double stats = 9; */
        if (message.stats.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* repeated proto.GemColor gem_sockets = 10; */
        if (message.gemSockets.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.gemSockets.length; i++)
                writer.int32(message.gemSockets[i]);
            writer.join();
        }
        /* repeated double socketBonus = 11; */
        if (message.socketBonus.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.socketBonus.length; i++)
                writer.double(message.socketBonus[i]);
            writer.join();
        }
        /* double weapon_damage_min = 12; */
        if (message.weaponDamageMin !== 0)
            writer.tag(12, WireType.Bit64).double(message.weaponDamageMin);
        /* double weapon_damage_max = 13; */
        if (message.weaponDamageMax !== 0)
            writer.tag(13, WireType.Bit64).double(message.weaponDamageMax);
        /* double weapon_speed = 14; */
        if (message.weaponSpeed !== 0)
            writer.tag(14, WireType.Bit64).double(message.weaponSpeed);
        /* int32 ilvl = 15; */
        if (message.ilvl !== 0)
            writer.tag(15, WireType.Varint).int32(message.ilvl);
        /* int32 phase = 16; */
        if (message.phase !== 0)
            writer.tag(16, WireType.Varint).int32(message.phase);
        /* proto.ItemQuality quality = 17; */
        if (message.quality !== 0)
            writer.tag(17, WireType.Varint).int32(message.quality);
        /* bool unique = 18; */
        if (message.unique !== false)
            writer.tag(18, WireType.Varint).bool(message.unique);
        /* bool heroic = 19; */
        if (message.heroic !== false)
            writer.tag(19, WireType.Varint).bool(message.heroic);
        /* repeated proto.Class class_allowlist = 20; */
        if (message.classAllowlist.length) {
            writer.tag(20, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.classAllowlist.length; i++)
                writer.int32(message.classAllowlist[i]);
            writer.join();
        }
        /* proto.Profession required_profession = 21; */
        if (message.requiredProfession !== 0)
            writer.tag(21, WireType.Varint).int32(message.requiredProfession);
        /* string set_name = 22; */
        if (message.setName !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.setName);
        /* proto.Expansion expansion = 24; */
        if (message.expansion !== 0)
            writer.tag(24, WireType.Varint).int32(message.expansion);
        /* repeated proto.UIItemSource sources = 23; */
        for (let i = 0; i < message.sources.length; i++)
            UIItemSource.internalBinaryWrite(message.sources[i], writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* proto.UIItem.FactionRestriction faction_restriction = 25; */
        if (message.factionRestriction !== 0)
            writer.tag(25, WireType.Varint).int32(message.factionRestriction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIItem
 */
export const UIItem = new UIItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIItemSource$Type extends MessageType<UIItemSource> {
    constructor() {
        super("proto.UIItemSource", [
            { no: 1, name: "crafted", kind: "message", oneof: "source", T: () => CraftedSource },
            { no: 2, name: "drop", kind: "message", oneof: "source", T: () => DropSource },
            { no: 3, name: "quest", kind: "message", oneof: "source", T: () => QuestSource },
            { no: 4, name: "sold_by", kind: "message", oneof: "source", T: () => SoldBySource },
            { no: 5, name: "rep", kind: "message", oneof: "source", T: () => RepSource }
        ]);
    }
    create(value?: PartialMessage<UIItemSource>): UIItemSource {
        const message = { source: { oneofKind: undefined } };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIItemSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIItemSource): UIItemSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.CraftedSource crafted */ 1:
                    message.source = {
                        oneofKind: "crafted",
                        crafted: CraftedSource.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).crafted)
                    };
                    break;
                case /* proto.DropSource drop */ 2:
                    message.source = {
                        oneofKind: "drop",
                        drop: DropSource.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).drop)
                    };
                    break;
                case /* proto.QuestSource quest */ 3:
                    message.source = {
                        oneofKind: "quest",
                        quest: QuestSource.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).quest)
                    };
                    break;
                case /* proto.SoldBySource sold_by */ 4:
                    message.source = {
                        oneofKind: "soldBy",
                        soldBy: SoldBySource.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).soldBy)
                    };
                    break;
                case /* proto.RepSource rep */ 5:
                    message.source = {
                        oneofKind: "rep",
                        rep: RepSource.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).rep)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIItemSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.CraftedSource crafted = 1; */
        if (message.source.oneofKind === "crafted")
            CraftedSource.internalBinaryWrite(message.source.crafted, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.DropSource drop = 2; */
        if (message.source.oneofKind === "drop")
            DropSource.internalBinaryWrite(message.source.drop, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.QuestSource quest = 3; */
        if (message.source.oneofKind === "quest")
            QuestSource.internalBinaryWrite(message.source.quest, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.SoldBySource sold_by = 4; */
        if (message.source.oneofKind === "soldBy")
            SoldBySource.internalBinaryWrite(message.source.soldBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.RepSource rep = 5; */
        if (message.source.oneofKind === "rep")
            RepSource.internalBinaryWrite(message.source.rep, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIItemSource
 */
export const UIItemSource = new UIItemSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CraftedSource$Type extends MessageType<CraftedSource> {
    constructor() {
        super("proto.CraftedSource", [
            { no: 1, name: "profession", kind: "enum", T: () => ["proto.Profession", Profession] },
            { no: 2, name: "spell_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CraftedSource>): CraftedSource {
        const message = { profession: 0, spellId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CraftedSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CraftedSource): CraftedSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Profession profession */ 1:
                    message.profession = reader.int32();
                    break;
                case /* int32 spell_id */ 2:
                    message.spellId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CraftedSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Profession profession = 1; */
        if (message.profession !== 0)
            writer.tag(1, WireType.Varint).int32(message.profession);
        /* int32 spell_id = 2; */
        if (message.spellId !== 0)
            writer.tag(2, WireType.Varint).int32(message.spellId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.CraftedSource
 */
export const CraftedSource = new CraftedSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DropSource$Type extends MessageType<DropSource> {
    constructor() {
        super("proto.DropSource", [
            { no: 1, name: "difficulty", kind: "enum", T: () => ["proto.DungeonDifficulty", DungeonDifficulty] },
            { no: 2, name: "npc_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "zone_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "other_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DropSource>): DropSource {
        const message = { difficulty: 0, npcId: 0, zoneId: 0, otherName: "", category: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DropSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DropSource): DropSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.DungeonDifficulty difficulty */ 1:
                    message.difficulty = reader.int32();
                    break;
                case /* int32 npc_id */ 2:
                    message.npcId = reader.int32();
                    break;
                case /* int32 zone_id */ 3:
                    message.zoneId = reader.int32();
                    break;
                case /* string other_name */ 4:
                    message.otherName = reader.string();
                    break;
                case /* string category */ 5:
                    message.category = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DropSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.DungeonDifficulty difficulty = 1; */
        if (message.difficulty !== 0)
            writer.tag(1, WireType.Varint).int32(message.difficulty);
        /* int32 npc_id = 2; */
        if (message.npcId !== 0)
            writer.tag(2, WireType.Varint).int32(message.npcId);
        /* int32 zone_id = 3; */
        if (message.zoneId !== 0)
            writer.tag(3, WireType.Varint).int32(message.zoneId);
        /* string other_name = 4; */
        if (message.otherName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.otherName);
        /* string category = 5; */
        if (message.category !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.category);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DropSource
 */
export const DropSource = new DropSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuestSource$Type extends MessageType<QuestSource> {
    constructor() {
        super("proto.QuestSource", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<QuestSource>): QuestSource {
        const message = { id: 0, name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<QuestSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuestSource): QuestSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuestSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.QuestSource
 */
export const QuestSource = new QuestSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SoldBySource$Type extends MessageType<SoldBySource> {
    constructor() {
        super("proto.SoldBySource", [
            { no: 1, name: "npc_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "npc_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "zone_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SoldBySource>): SoldBySource {
        const message = { npcId: 0, npcName: "", zoneId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SoldBySource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SoldBySource): SoldBySource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 npc_id */ 1:
                    message.npcId = reader.int32();
                    break;
                case /* string npc_name */ 2:
                    message.npcName = reader.string();
                    break;
                case /* int32 zone_id */ 3:
                    message.zoneId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SoldBySource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 npc_id = 1; */
        if (message.npcId !== 0)
            writer.tag(1, WireType.Varint).int32(message.npcId);
        /* string npc_name = 2; */
        if (message.npcName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.npcName);
        /* int32 zone_id = 3; */
        if (message.zoneId !== 0)
            writer.tag(3, WireType.Varint).int32(message.zoneId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SoldBySource
 */
export const SoldBySource = new SoldBySource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepSource$Type extends MessageType<RepSource> {
    constructor() {
        super("proto.RepSource", [
            { no: 1, name: "rep_faction_id", kind: "enum", T: () => ["proto.RepFaction", RepFaction] },
            { no: 2, name: "rep_level", kind: "enum", T: () => ["proto.RepLevel", RepLevel] },
            { no: 3, name: "faction_id", kind: "enum", T: () => ["proto.Faction", Faction] }
        ]);
    }
    create(value?: PartialMessage<RepSource>): RepSource {
        const message = { repFactionId: 0, repLevel: 0, factionId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RepSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RepSource): RepSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RepFaction rep_faction_id */ 1:
                    message.repFactionId = reader.int32();
                    break;
                case /* proto.RepLevel rep_level */ 2:
                    message.repLevel = reader.int32();
                    break;
                case /* proto.Faction faction_id */ 3:
                    message.factionId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RepSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RepFaction rep_faction_id = 1; */
        if (message.repFactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.repFactionId);
        /* proto.RepLevel rep_level = 2; */
        if (message.repLevel !== 0)
            writer.tag(2, WireType.Varint).int32(message.repLevel);
        /* proto.Faction faction_id = 3; */
        if (message.factionId !== 0)
            writer.tag(3, WireType.Varint).int32(message.factionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RepSource
 */
export const RepSource = new RepSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIEnchant$Type extends MessageType<UIEnchant> {
    constructor() {
        super("proto.UIEnchant", [
            { no: 1, name: "effect_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "spell_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "icon", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "type", kind: "enum", T: () => ["proto.ItemType", ItemType] },
            { no: 13, name: "extra_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.ItemType", ItemType] },
            { no: 7, name: "enchant_type", kind: "enum", T: () => ["proto.EnchantType", EnchantType] },
            { no: 8, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "quality", kind: "enum", T: () => ["proto.ItemQuality", ItemQuality] },
            { no: 10, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "class_allowlist", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Class", Class] },
            { no: 12, name: "required_profession", kind: "enum", T: () => ["proto.Profession", Profession] }
        ]);
    }
    create(value?: PartialMessage<UIEnchant>): UIEnchant {
        const message = { effectId: 0, itemId: 0, spellId: 0, name: "", icon: "", type: 0, extraTypes: [], enchantType: 0, stats: [], quality: 0, phase: 0, classAllowlist: [], requiredProfession: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIEnchant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIEnchant): UIEnchant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 effect_id */ 1:
                    message.effectId = reader.int32();
                    break;
                case /* int32 item_id */ 2:
                    message.itemId = reader.int32();
                    break;
                case /* int32 spell_id */ 3:
                    message.spellId = reader.int32();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string icon */ 5:
                    message.icon = reader.string();
                    break;
                case /* proto.ItemType type */ 6:
                    message.type = reader.int32();
                    break;
                case /* repeated proto.ItemType extra_types */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.extraTypes.push(reader.int32());
                    else
                        message.extraTypes.push(reader.int32());
                    break;
                case /* proto.EnchantType enchant_type */ 7:
                    message.enchantType = reader.int32();
                    break;
                case /* repeated double stats */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* proto.ItemQuality quality */ 9:
                    message.quality = reader.int32();
                    break;
                case /* int32 phase */ 10:
                    message.phase = reader.int32();
                    break;
                case /* repeated proto.Class class_allowlist */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.classAllowlist.push(reader.int32());
                    else
                        message.classAllowlist.push(reader.int32());
                    break;
                case /* proto.Profession required_profession */ 12:
                    message.requiredProfession = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIEnchant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 effect_id = 1; */
        if (message.effectId !== 0)
            writer.tag(1, WireType.Varint).int32(message.effectId);
        /* int32 item_id = 2; */
        if (message.itemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.itemId);
        /* int32 spell_id = 3; */
        if (message.spellId !== 0)
            writer.tag(3, WireType.Varint).int32(message.spellId);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string icon = 5; */
        if (message.icon !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.icon);
        /* proto.ItemType type = 6; */
        if (message.type !== 0)
            writer.tag(6, WireType.Varint).int32(message.type);
        /* repeated proto.ItemType extra_types = 13; */
        if (message.extraTypes.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.extraTypes.length; i++)
                writer.int32(message.extraTypes[i]);
            writer.join();
        }
        /* proto.EnchantType enchant_type = 7; */
        if (message.enchantType !== 0)
            writer.tag(7, WireType.Varint).int32(message.enchantType);
        /* repeated double stats = 8; */
        if (message.stats.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* proto.ItemQuality quality = 9; */
        if (message.quality !== 0)
            writer.tag(9, WireType.Varint).int32(message.quality);
        /* int32 phase = 10; */
        if (message.phase !== 0)
            writer.tag(10, WireType.Varint).int32(message.phase);
        /* repeated proto.Class class_allowlist = 11; */
        if (message.classAllowlist.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.classAllowlist.length; i++)
                writer.int32(message.classAllowlist[i]);
            writer.join();
        }
        /* proto.Profession required_profession = 12; */
        if (message.requiredProfession !== 0)
            writer.tag(12, WireType.Varint).int32(message.requiredProfession);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIEnchant
 */
export const UIEnchant = new UIEnchant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIGem$Type extends MessageType<UIGem> {
    constructor() {
        super("proto.UIGem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "icon", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "color", kind: "enum", T: () => ["proto.GemColor", GemColor] },
            { no: 5, name: "stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "quality", kind: "enum", T: () => ["proto.ItemQuality", ItemQuality] },
            { no: 8, name: "unique", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "required_profession", kind: "enum", T: () => ["proto.Profession", Profession] }
        ]);
    }
    create(value?: PartialMessage<UIGem>): UIGem {
        const message = { id: 0, name: "", icon: "", color: 0, stats: [], phase: 0, quality: 0, unique: false, requiredProfession: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UIGem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIGem): UIGem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string icon */ 3:
                    message.icon = reader.string();
                    break;
                case /* proto.GemColor color */ 4:
                    message.color = reader.int32();
                    break;
                case /* repeated double stats */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stats.push(reader.double());
                    else
                        message.stats.push(reader.double());
                    break;
                case /* int32 phase */ 6:
                    message.phase = reader.int32();
                    break;
                case /* proto.ItemQuality quality */ 7:
                    message.quality = reader.int32();
                    break;
                case /* bool unique */ 8:
                    message.unique = reader.bool();
                    break;
                case /* proto.Profession required_profession */ 9:
                    message.requiredProfession = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIGem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string icon = 3; */
        if (message.icon !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.icon);
        /* proto.GemColor color = 4; */
        if (message.color !== 0)
            writer.tag(4, WireType.Varint).int32(message.color);
        /* repeated double stats = 5; */
        if (message.stats.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stats.length; i++)
                writer.double(message.stats[i]);
            writer.join();
        }
        /* int32 phase = 6; */
        if (message.phase !== 0)
            writer.tag(6, WireType.Varint).int32(message.phase);
        /* proto.ItemQuality quality = 7; */
        if (message.quality !== 0)
            writer.tag(7, WireType.Varint).int32(message.quality);
        /* bool unique = 8; */
        if (message.unique !== false)
            writer.tag(8, WireType.Varint).bool(message.unique);
        /* proto.Profession required_profession = 9; */
        if (message.requiredProfession !== 0)
            writer.tag(9, WireType.Varint).int32(message.requiredProfession);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UIGem
 */
export const UIGem = new UIGem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IconData$Type extends MessageType<IconData> {
    constructor() {
        super("proto.IconData", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "icon", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IconData>): IconData {
        const message = { id: 0, name: "", icon: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IconData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IconData): IconData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string icon */ 3:
                    message.icon = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IconData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string icon = 3; */
        if (message.icon !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.icon);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.IconData
 */
export const IconData = new IconData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GlyphID$Type extends MessageType<GlyphID> {
    constructor() {
        super("proto.GlyphID", [
            { no: 1, name: "item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "spell_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GlyphID>): GlyphID {
        const message = { itemId: 0, spellId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GlyphID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GlyphID): GlyphID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 item_id */ 1:
                    message.itemId = reader.int32();
                    break;
                case /* int32 spell_id */ 2:
                    message.spellId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GlyphID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 item_id = 1; */
        if (message.itemId !== 0)
            writer.tag(1, WireType.Varint).int32(message.itemId);
        /* int32 spell_id = 2; */
        if (message.spellId !== 0)
            writer.tag(2, WireType.Varint).int32(message.spellId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.GlyphID
 */
export const GlyphID = new GlyphID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseFilters$Type extends MessageType<DatabaseFilters> {
    constructor() {
        super("proto.DatabaseFilters", [
            { no: 1, name: "armor_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.ArmorType", ArmorType] },
            { no: 2, name: "weapon_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.WeaponType", WeaponType] },
            { no: 16, name: "ranged_weapon_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.RangedWeaponType", RangedWeaponType] },
            { no: 17, name: "sources", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.SourceFilterOption", SourceFilterOption] },
            { no: 18, name: "raids", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.RaidFilterOption", RaidFilterOption] },
            { no: 19, name: "faction_restriction", kind: "enum", T: () => ["proto.UIItem.FactionRestriction", UIItem_FactionRestriction, "FACTION_RESTRICTION_"] },
            { no: 4, name: "min_mh_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_mh_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "min_oh_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "max_oh_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "min_ranged_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "max_ranged_weapon_speed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "one_handed_weapons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "two_handed_weapons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "matching_gems_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "favorite_items", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "favorite_gems", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "favorite_enchants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DatabaseFilters>): DatabaseFilters {
        const message = { armorTypes: [], weaponTypes: [], rangedWeaponTypes: [], sources: [], raids: [], factionRestriction: 0, minMhWeaponSpeed: 0, maxMhWeaponSpeed: 0, minOhWeaponSpeed: 0, maxOhWeaponSpeed: 0, minRangedWeaponSpeed: 0, maxRangedWeaponSpeed: 0, oneHandedWeapons: false, twoHandedWeapons: false, matchingGemsOnly: false, favoriteItems: [], favoriteGems: [], favoriteEnchants: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DatabaseFilters>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DatabaseFilters): DatabaseFilters {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.ArmorType armor_types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.armorTypes.push(reader.int32());
                    else
                        message.armorTypes.push(reader.int32());
                    break;
                case /* repeated proto.WeaponType weapon_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.weaponTypes.push(reader.int32());
                    else
                        message.weaponTypes.push(reader.int32());
                    break;
                case /* repeated proto.RangedWeaponType ranged_weapon_types */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.rangedWeaponTypes.push(reader.int32());
                    else
                        message.rangedWeaponTypes.push(reader.int32());
                    break;
                case /* repeated proto.SourceFilterOption sources */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sources.push(reader.int32());
                    else
                        message.sources.push(reader.int32());
                    break;
                case /* repeated proto.RaidFilterOption raids */ 18:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.raids.push(reader.int32());
                    else
                        message.raids.push(reader.int32());
                    break;
                case /* proto.UIItem.FactionRestriction faction_restriction */ 19:
                    message.factionRestriction = reader.int32();
                    break;
                case /* double min_mh_weapon_speed */ 4:
                    message.minMhWeaponSpeed = reader.double();
                    break;
                case /* double max_mh_weapon_speed */ 5:
                    message.maxMhWeaponSpeed = reader.double();
                    break;
                case /* double min_oh_weapon_speed */ 9:
                    message.minOhWeaponSpeed = reader.double();
                    break;
                case /* double max_oh_weapon_speed */ 10:
                    message.maxOhWeaponSpeed = reader.double();
                    break;
                case /* double min_ranged_weapon_speed */ 14:
                    message.minRangedWeaponSpeed = reader.double();
                    break;
                case /* double max_ranged_weapon_speed */ 15:
                    message.maxRangedWeaponSpeed = reader.double();
                    break;
                case /* bool one_handed_weapons */ 6:
                    message.oneHandedWeapons = reader.bool();
                    break;
                case /* bool two_handed_weapons */ 7:
                    message.twoHandedWeapons = reader.bool();
                    break;
                case /* bool matching_gems_only */ 8:
                    message.matchingGemsOnly = reader.bool();
                    break;
                case /* repeated int32 favorite_items */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.favoriteItems.push(reader.int32());
                    else
                        message.favoriteItems.push(reader.int32());
                    break;
                case /* repeated int32 favorite_gems */ 12:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.favoriteGems.push(reader.int32());
                    else
                        message.favoriteGems.push(reader.int32());
                    break;
                case /* repeated string favorite_enchants */ 13:
                    message.favoriteEnchants.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DatabaseFilters, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.ArmorType armor_types = 1; */
        if (message.armorTypes.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.armorTypes.length; i++)
                writer.int32(message.armorTypes[i]);
            writer.join();
        }
        /* repeated proto.WeaponType weapon_types = 2; */
        if (message.weaponTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.weaponTypes.length; i++)
                writer.int32(message.weaponTypes[i]);
            writer.join();
        }
        /* repeated proto.RangedWeaponType ranged_weapon_types = 16; */
        if (message.rangedWeaponTypes.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.rangedWeaponTypes.length; i++)
                writer.int32(message.rangedWeaponTypes[i]);
            writer.join();
        }
        /* repeated proto.SourceFilterOption sources = 17; */
        if (message.sources.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sources.length; i++)
                writer.int32(message.sources[i]);
            writer.join();
        }
        /* repeated proto.RaidFilterOption raids = 18; */
        if (message.raids.length) {
            writer.tag(18, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.raids.length; i++)
                writer.int32(message.raids[i]);
            writer.join();
        }
        /* proto.UIItem.FactionRestriction faction_restriction = 19; */
        if (message.factionRestriction !== 0)
            writer.tag(19, WireType.Varint).int32(message.factionRestriction);
        /* double min_mh_weapon_speed = 4; */
        if (message.minMhWeaponSpeed !== 0)
            writer.tag(4, WireType.Bit64).double(message.minMhWeaponSpeed);
        /* double max_mh_weapon_speed = 5; */
        if (message.maxMhWeaponSpeed !== 0)
            writer.tag(5, WireType.Bit64).double(message.maxMhWeaponSpeed);
        /* double min_oh_weapon_speed = 9; */
        if (message.minOhWeaponSpeed !== 0)
            writer.tag(9, WireType.Bit64).double(message.minOhWeaponSpeed);
        /* double max_oh_weapon_speed = 10; */
        if (message.maxOhWeaponSpeed !== 0)
            writer.tag(10, WireType.Bit64).double(message.maxOhWeaponSpeed);
        /* double min_ranged_weapon_speed = 14; */
        if (message.minRangedWeaponSpeed !== 0)
            writer.tag(14, WireType.Bit64).double(message.minRangedWeaponSpeed);
        /* double max_ranged_weapon_speed = 15; */
        if (message.maxRangedWeaponSpeed !== 0)
            writer.tag(15, WireType.Bit64).double(message.maxRangedWeaponSpeed);
        /* bool one_handed_weapons = 6; */
        if (message.oneHandedWeapons !== false)
            writer.tag(6, WireType.Varint).bool(message.oneHandedWeapons);
        /* bool two_handed_weapons = 7; */
        if (message.twoHandedWeapons !== false)
            writer.tag(7, WireType.Varint).bool(message.twoHandedWeapons);
        /* bool matching_gems_only = 8; */
        if (message.matchingGemsOnly !== false)
            writer.tag(8, WireType.Varint).bool(message.matchingGemsOnly);
        /* repeated int32 favorite_items = 11; */
        if (message.favoriteItems.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.favoriteItems.length; i++)
                writer.int32(message.favoriteItems[i]);
            writer.join();
        }
        /* repeated int32 favorite_gems = 12; */
        if (message.favoriteGems.length) {
            writer.tag(12, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.favoriteGems.length; i++)
                writer.int32(message.favoriteGems[i]);
            writer.join();
        }
        /* repeated string favorite_enchants = 13; */
        for (let i = 0; i < message.favoriteEnchants.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.favoriteEnchants[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DatabaseFilters
 */
export const DatabaseFilters = new DatabaseFilters$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSettings$Type extends MessageType<SimSettings> {
    constructor() {
        super("proto.SimSettings", [
            { no: 1, name: "iterations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "fixed_rng_seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "show_damage_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "show_threat_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "show_healing_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "show_experimental", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "show_ep_values", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "faction", kind: "enum", T: () => ["proto.Faction", Faction] },
            { no: 10, name: "filters", kind: "message", T: () => DatabaseFilters }
        ]);
    }
    create(value?: PartialMessage<SimSettings>): SimSettings {
        const message = { iterations: 0, phase: 0, fixedRngSeed: 0n, showDamageMetrics: false, showThreatMetrics: false, showHealingMetrics: false, showExperimental: false, showEpValues: false, language: "", faction: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimSettings): SimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 iterations */ 1:
                    message.iterations = reader.int32();
                    break;
                case /* int32 phase */ 2:
                    message.phase = reader.int32();
                    break;
                case /* int64 fixed_rng_seed */ 3:
                    message.fixedRngSeed = reader.int64().toBigInt();
                    break;
                case /* bool show_damage_metrics */ 8:
                    message.showDamageMetrics = reader.bool();
                    break;
                case /* bool show_threat_metrics */ 4:
                    message.showThreatMetrics = reader.bool();
                    break;
                case /* bool show_healing_metrics */ 7:
                    message.showHealingMetrics = reader.bool();
                    break;
                case /* bool show_experimental */ 5:
                    message.showExperimental = reader.bool();
                    break;
                case /* bool show_ep_values */ 11:
                    message.showEpValues = reader.bool();
                    break;
                case /* string language */ 9:
                    message.language = reader.string();
                    break;
                case /* proto.Faction faction */ 6:
                    message.faction = reader.int32();
                    break;
                case /* proto.DatabaseFilters filters */ 10:
                    message.filters = DatabaseFilters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 iterations = 1; */
        if (message.iterations !== 0)
            writer.tag(1, WireType.Varint).int32(message.iterations);
        /* int32 phase = 2; */
        if (message.phase !== 0)
            writer.tag(2, WireType.Varint).int32(message.phase);
        /* int64 fixed_rng_seed = 3; */
        if (message.fixedRngSeed !== 0n)
            writer.tag(3, WireType.Varint).int64(message.fixedRngSeed);
        /* bool show_damage_metrics = 8; */
        if (message.showDamageMetrics !== false)
            writer.tag(8, WireType.Varint).bool(message.showDamageMetrics);
        /* bool show_threat_metrics = 4; */
        if (message.showThreatMetrics !== false)
            writer.tag(4, WireType.Varint).bool(message.showThreatMetrics);
        /* bool show_healing_metrics = 7; */
        if (message.showHealingMetrics !== false)
            writer.tag(7, WireType.Varint).bool(message.showHealingMetrics);
        /* bool show_experimental = 5; */
        if (message.showExperimental !== false)
            writer.tag(5, WireType.Varint).bool(message.showExperimental);
        /* bool show_ep_values = 11; */
        if (message.showEpValues !== false)
            writer.tag(11, WireType.Varint).bool(message.showEpValues);
        /* string language = 9; */
        if (message.language !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.language);
        /* proto.Faction faction = 6; */
        if (message.faction !== 0)
            writer.tag(6, WireType.Varint).int32(message.faction);
        /* proto.DatabaseFilters filters = 10; */
        if (message.filters)
            DatabaseFilters.internalBinaryWrite(message.filters, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimSettings
 */
export const SimSettings = new SimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IndividualSimSettings$Type extends MessageType<IndividualSimSettings> {
    constructor() {
        super("proto.IndividualSimSettings", [
            { no: 5, name: "settings", kind: "message", T: () => SimSettings },
            { no: 1, name: "raid_buffs", kind: "message", T: () => RaidBuffs },
            { no: 8, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 7, name: "tanks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitReference },
            { no: 2, name: "party_buffs", kind: "message", T: () => PartyBuffs },
            { no: 3, name: "player", kind: "message", T: () => Player },
            { no: 4, name: "encounter", kind: "message", T: () => Encounter },
            { no: 9, name: "target_dummies", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "ep_weights_stats", kind: "message", T: () => UnitStats },
            { no: 11, name: "ep_ratios", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "dps_ref_stat", kind: "enum", T: () => ["proto.Stat", Stat] },
            { no: 13, name: "heal_ref_stat", kind: "enum", T: () => ["proto.Stat", Stat] },
            { no: 14, name: "tank_ref_stat", kind: "enum", T: () => ["proto.Stat", Stat] }
        ]);
    }
    create(value?: PartialMessage<IndividualSimSettings>): IndividualSimSettings {
        const message = { tanks: [], targetDummies: 0, epRatios: [], dpsRefStat: 0, healRefStat: 0, tankRefStat: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IndividualSimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IndividualSimSettings): IndividualSimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimSettings settings */ 5:
                    message.settings = SimSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* proto.RaidBuffs raid_buffs */ 1:
                    message.raidBuffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.raidBuffs);
                    break;
                case /* proto.Debuffs debuffs */ 8:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* repeated proto.UnitReference tanks */ 7:
                    message.tanks.push(UnitReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.PartyBuffs party_buffs */ 2:
                    message.partyBuffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.partyBuffs);
                    break;
                case /* proto.Player player */ 3:
                    message.player = Player.internalBinaryRead(reader, reader.uint32(), options, message.player);
                    break;
                case /* proto.Encounter encounter */ 4:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                case /* int32 target_dummies */ 9:
                    message.targetDummies = reader.int32();
                    break;
                case /* proto.UnitStats ep_weights_stats */ 10:
                    message.epWeightsStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.epWeightsStats);
                    break;
                case /* repeated double ep_ratios */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.epRatios.push(reader.double());
                    else
                        message.epRatios.push(reader.double());
                    break;
                case /* proto.Stat dps_ref_stat */ 12:
                    message.dpsRefStat = reader.int32();
                    break;
                case /* proto.Stat heal_ref_stat */ 13:
                    message.healRefStat = reader.int32();
                    break;
                case /* proto.Stat tank_ref_stat */ 14:
                    message.tankRefStat = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IndividualSimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimSettings settings = 5; */
        if (message.settings)
            SimSettings.internalBinaryWrite(message.settings, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidBuffs raid_buffs = 1; */
        if (message.raidBuffs)
            RaidBuffs.internalBinaryWrite(message.raidBuffs, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 8; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UnitReference tanks = 7; */
        for (let i = 0; i < message.tanks.length; i++)
            UnitReference.internalBinaryWrite(message.tanks[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs party_buffs = 2; */
        if (message.partyBuffs)
            PartyBuffs.internalBinaryWrite(message.partyBuffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.Player player = 3; */
        if (message.player)
            Player.internalBinaryWrite(message.player, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 4; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 target_dummies = 9; */
        if (message.targetDummies !== 0)
            writer.tag(9, WireType.Varint).int32(message.targetDummies);
        /* proto.UnitStats ep_weights_stats = 10; */
        if (message.epWeightsStats)
            UnitStats.internalBinaryWrite(message.epWeightsStats, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated double ep_ratios = 11; */
        if (message.epRatios.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.epRatios.length; i++)
                writer.double(message.epRatios[i]);
            writer.join();
        }
        /* proto.Stat dps_ref_stat = 12; */
        if (message.dpsRefStat !== 0)
            writer.tag(12, WireType.Varint).int32(message.dpsRefStat);
        /* proto.Stat heal_ref_stat = 13; */
        if (message.healRefStat !== 0)
            writer.tag(13, WireType.Varint).int32(message.healRefStat);
        /* proto.Stat tank_ref_stat = 14; */
        if (message.tankRefStat !== 0)
            writer.tag(14, WireType.Varint).int32(message.tankRefStat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.IndividualSimSettings
 */
export const IndividualSimSettings = new IndividualSimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedGearSet$Type extends MessageType<SavedGearSet> {
    constructor() {
        super("proto.SavedGearSet", [
            { no: 1, name: "gear", kind: "message", T: () => EquipmentSpec },
            { no: 3, name: "bonus_stats_stats", kind: "message", T: () => UnitStats }
        ]);
    }
    create(value?: PartialMessage<SavedGearSet>): SavedGearSet {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedGearSet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedGearSet): SavedGearSet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.EquipmentSpec gear */ 1:
                    message.gear = EquipmentSpec.internalBinaryRead(reader, reader.uint32(), options, message.gear);
                    break;
                case /* proto.UnitStats bonus_stats_stats */ 3:
                    message.bonusStatsStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.bonusStatsStats);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedGearSet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.EquipmentSpec gear = 1; */
        if (message.gear)
            EquipmentSpec.internalBinaryWrite(message.gear, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats bonus_stats_stats = 3; */
        if (message.bonusStatsStats)
            UnitStats.internalBinaryWrite(message.bonusStatsStats, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedGearSet
 */
export const SavedGearSet = new SavedGearSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedSettings$Type extends MessageType<SavedSettings> {
    constructor() {
        super("proto.SavedSettings", [
            { no: 1, name: "raid_buffs", kind: "message", T: () => RaidBuffs },
            { no: 2, name: "party_buffs", kind: "message", T: () => PartyBuffs },
            { no: 7, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 3, name: "player_buffs", kind: "message", T: () => IndividualBuffs },
            { no: 4, name: "consumes", kind: "message", T: () => Consumes },
            { no: 5, name: "race", kind: "enum", T: () => ["proto.Race", Race] },
            { no: 9, name: "professions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Profession", Profession] },
            { no: 18, name: "enable_item_swap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "item_swap", kind: "message", T: () => ItemSwap },
            { no: 10, name: "reaction_time_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "channel_clip_delay_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "in_front_of_target", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "distance_from_target", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "healing_model", kind: "message", T: () => HealingModel },
            { no: 15, name: "nibelung_average_casts", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "nibelung_average_casts_set", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SavedSettings>): SavedSettings {
        const message = { race: 0, professions: [], enableItemSwap: false, reactionTimeMs: 0, channelClipDelayMs: 0, inFrontOfTarget: false, distanceFromTarget: 0, nibelungAverageCasts: 0, nibelungAverageCastsSet: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedSettings): SavedSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidBuffs raid_buffs */ 1:
                    message.raidBuffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.raidBuffs);
                    break;
                case /* proto.PartyBuffs party_buffs */ 2:
                    message.partyBuffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.partyBuffs);
                    break;
                case /* proto.Debuffs debuffs */ 7:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* proto.IndividualBuffs player_buffs */ 3:
                    message.playerBuffs = IndividualBuffs.internalBinaryRead(reader, reader.uint32(), options, message.playerBuffs);
                    break;
                case /* proto.Consumes consumes */ 4:
                    message.consumes = Consumes.internalBinaryRead(reader, reader.uint32(), options, message.consumes);
                    break;
                case /* proto.Race race */ 5:
                    message.race = reader.int32();
                    break;
                case /* repeated proto.Profession professions */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.professions.push(reader.int32());
                    else
                        message.professions.push(reader.int32());
                    break;
                case /* bool enable_item_swap */ 18:
                    message.enableItemSwap = reader.bool();
                    break;
                case /* proto.ItemSwap item_swap */ 17:
                    message.itemSwap = ItemSwap.internalBinaryRead(reader, reader.uint32(), options, message.itemSwap);
                    break;
                case /* int32 reaction_time_ms */ 10:
                    message.reactionTimeMs = reader.int32();
                    break;
                case /* int32 channel_clip_delay_ms */ 14:
                    message.channelClipDelayMs = reader.int32();
                    break;
                case /* bool in_front_of_target */ 11:
                    message.inFrontOfTarget = reader.bool();
                    break;
                case /* double distance_from_target */ 12:
                    message.distanceFromTarget = reader.double();
                    break;
                case /* proto.HealingModel healing_model */ 13:
                    message.healingModel = HealingModel.internalBinaryRead(reader, reader.uint32(), options, message.healingModel);
                    break;
                case /* double nibelung_average_casts */ 15:
                    message.nibelungAverageCasts = reader.double();
                    break;
                case /* bool nibelung_average_casts_set */ 16:
                    message.nibelungAverageCastsSet = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidBuffs raid_buffs = 1; */
        if (message.raidBuffs)
            RaidBuffs.internalBinaryWrite(message.raidBuffs, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs party_buffs = 2; */
        if (message.partyBuffs)
            PartyBuffs.internalBinaryWrite(message.partyBuffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 7; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.IndividualBuffs player_buffs = 3; */
        if (message.playerBuffs)
            IndividualBuffs.internalBinaryWrite(message.playerBuffs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Consumes consumes = 4; */
        if (message.consumes)
            Consumes.internalBinaryWrite(message.consumes, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.Race race = 5; */
        if (message.race !== 0)
            writer.tag(5, WireType.Varint).int32(message.race);
        /* repeated proto.Profession professions = 9; */
        if (message.professions.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.professions.length; i++)
                writer.int32(message.professions[i]);
            writer.join();
        }
        /* bool enable_item_swap = 18; */
        if (message.enableItemSwap !== false)
            writer.tag(18, WireType.Varint).bool(message.enableItemSwap);
        /* proto.ItemSwap item_swap = 17; */
        if (message.itemSwap)
            ItemSwap.internalBinaryWrite(message.itemSwap, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* int32 reaction_time_ms = 10; */
        if (message.reactionTimeMs !== 0)
            writer.tag(10, WireType.Varint).int32(message.reactionTimeMs);
        /* int32 channel_clip_delay_ms = 14; */
        if (message.channelClipDelayMs !== 0)
            writer.tag(14, WireType.Varint).int32(message.channelClipDelayMs);
        /* bool in_front_of_target = 11; */
        if (message.inFrontOfTarget !== false)
            writer.tag(11, WireType.Varint).bool(message.inFrontOfTarget);
        /* double distance_from_target = 12; */
        if (message.distanceFromTarget !== 0)
            writer.tag(12, WireType.Bit64).double(message.distanceFromTarget);
        /* proto.HealingModel healing_model = 13; */
        if (message.healingModel)
            HealingModel.internalBinaryWrite(message.healingModel, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* double nibelung_average_casts = 15; */
        if (message.nibelungAverageCasts !== 0)
            writer.tag(15, WireType.Bit64).double(message.nibelungAverageCasts);
        /* bool nibelung_average_casts_set = 16; */
        if (message.nibelungAverageCastsSet !== false)
            writer.tag(16, WireType.Varint).bool(message.nibelungAverageCastsSet);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedSettings
 */
export const SavedSettings = new SavedSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedTalents$Type extends MessageType<SavedTalents> {
    constructor() {
        super("proto.SavedTalents", [
            { no: 1, name: "talents_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "glyphs", kind: "message", T: () => Glyphs }
        ]);
    }
    create(value?: PartialMessage<SavedTalents>): SavedTalents {
        const message = { talentsString: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedTalents): SavedTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string talents_string */ 1:
                    message.talentsString = reader.string();
                    break;
                case /* proto.Glyphs glyphs */ 2:
                    message.glyphs = Glyphs.internalBinaryRead(reader, reader.uint32(), options, message.glyphs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string talents_string = 1; */
        if (message.talentsString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.talentsString);
        /* proto.Glyphs glyphs = 2; */
        if (message.glyphs)
            Glyphs.internalBinaryWrite(message.glyphs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedTalents
 */
export const SavedTalents = new SavedTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedRotation$Type extends MessageType<SavedRotation> {
    constructor() {
        super("proto.SavedRotation", [
            { no: 1, name: "rotation", kind: "message", T: () => APLRotation }
        ]);
    }
    create(value?: PartialMessage<SavedRotation>): SavedRotation {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedRotation): SavedRotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.APLRotation rotation */ 1:
                    message.rotation = APLRotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.APLRotation rotation = 1; */
        if (message.rotation)
            APLRotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedRotation
 */
export const SavedRotation = new SavedRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlessingsAssignment$Type extends MessageType<BlessingsAssignment> {
    constructor() {
        super("proto.BlessingsAssignment", [
            { no: 1, name: "blessings", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Blessings", Blessings] }
        ]);
    }
    create(value?: PartialMessage<BlessingsAssignment>): BlessingsAssignment {
        const message = { blessings: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BlessingsAssignment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BlessingsAssignment): BlessingsAssignment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.Blessings blessings */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.blessings.push(reader.int32());
                    else
                        message.blessings.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BlessingsAssignment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.Blessings blessings = 1; */
        if (message.blessings.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.blessings.length; i++)
                writer.int32(message.blessings[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BlessingsAssignment
 */
export const BlessingsAssignment = new BlessingsAssignment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlessingsAssignments$Type extends MessageType<BlessingsAssignments> {
    constructor() {
        super("proto.BlessingsAssignments", [
            { no: 1, name: "paladins", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlessingsAssignment }
        ]);
    }
    create(value?: PartialMessage<BlessingsAssignments>): BlessingsAssignments {
        const message = { paladins: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BlessingsAssignments>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BlessingsAssignments): BlessingsAssignments {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.BlessingsAssignment paladins */ 1:
                    message.paladins.push(BlessingsAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BlessingsAssignments, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.BlessingsAssignment paladins = 1; */
        for (let i = 0; i < message.paladins.length; i++)
            BlessingsAssignment.internalBinaryWrite(message.paladins[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BlessingsAssignments
 */
export const BlessingsAssignments = new BlessingsAssignments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedEncounter$Type extends MessageType<SavedEncounter> {
    constructor() {
        super("proto.SavedEncounter", [
            { no: 1, name: "encounter", kind: "message", T: () => Encounter }
        ]);
    }
    create(value?: PartialMessage<SavedEncounter>): SavedEncounter {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedEncounter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedEncounter): SavedEncounter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Encounter encounter */ 1:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedEncounter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Encounter encounter = 1; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedEncounter
 */
export const SavedEncounter = new SavedEncounter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedRaid$Type extends MessageType<SavedRaid> {
    constructor() {
        super("proto.SavedRaid", [
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 3, name: "blessings", kind: "message", T: () => BlessingsAssignments },
            { no: 4, name: "faction", kind: "enum", T: () => ["proto.Faction", Faction] },
            { no: 5, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SavedRaid>): SavedRaid {
        const message = { faction: 0, phase: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedRaid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedRaid): SavedRaid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* proto.BlessingsAssignments blessings */ 3:
                    message.blessings = BlessingsAssignments.internalBinaryRead(reader, reader.uint32(), options, message.blessings);
                    break;
                case /* proto.Faction faction */ 4:
                    message.faction = reader.int32();
                    break;
                case /* int32 phase */ 5:
                    message.phase = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedRaid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.BlessingsAssignments blessings = 3; */
        if (message.blessings)
            BlessingsAssignments.internalBinaryWrite(message.blessings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Faction faction = 4; */
        if (message.faction !== 0)
            writer.tag(4, WireType.Varint).int32(message.faction);
        /* int32 phase = 5; */
        if (message.phase !== 0)
            writer.tag(5, WireType.Varint).int32(message.phase);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedRaid
 */
export const SavedRaid = new SavedRaid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidSimSettings$Type extends MessageType<RaidSimSettings> {
    constructor() {
        super("proto.RaidSimSettings", [
            { no: 5, name: "settings", kind: "message", T: () => SimSettings },
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 3, name: "blessings", kind: "message", T: () => BlessingsAssignments },
            { no: 4, name: "encounter", kind: "message", T: () => Encounter }
        ]);
    }
    create(value?: PartialMessage<RaidSimSettings>): RaidSimSettings {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidSimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidSimSettings): RaidSimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimSettings settings */ 5:
                    message.settings = SimSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* proto.BlessingsAssignments blessings */ 3:
                    message.blessings = BlessingsAssignments.internalBinaryRead(reader, reader.uint32(), options, message.blessings);
                    break;
                case /* proto.Encounter encounter */ 4:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidSimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimSettings settings = 5; */
        if (message.settings)
            SimSettings.internalBinaryWrite(message.settings, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.BlessingsAssignments blessings = 3; */
        if (message.blessings)
            BlessingsAssignments.internalBinaryWrite(message.blessings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 4; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidSimSettings
 */
export const RaidSimSettings = new RaidSimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimRun$Type extends MessageType<SimRun> {
    constructor() {
        super("proto.SimRun", [
            { no: 1, name: "request", kind: "message", T: () => RaidSimRequest },
            { no: 2, name: "result", kind: "message", T: () => RaidSimResult }
        ]);
    }
    create(value?: PartialMessage<SimRun>): SimRun {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimRun>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimRun): SimRun {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidSimRequest request */ 1:
                    message.request = RaidSimRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* proto.RaidSimResult result */ 2:
                    message.result = RaidSimResult.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimRun, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidSimRequest request = 1; */
        if (message.request)
            RaidSimRequest.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidSimResult result = 2; */
        if (message.result)
            RaidSimResult.internalBinaryWrite(message.result, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimRun
 */
export const SimRun = new SimRun$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimRunData$Type extends MessageType<SimRunData> {
    constructor() {
        super("proto.SimRunData", [
            { no: 1, name: "run", kind: "message", T: () => SimRun },
            { no: 2, name: "reference_run", kind: "message", T: () => SimRun }
        ]);
    }
    create(value?: PartialMessage<SimRunData>): SimRunData {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimRunData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimRunData): SimRunData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimRun run */ 1:
                    message.run = SimRun.internalBinaryRead(reader, reader.uint32(), options, message.run);
                    break;
                case /* proto.SimRun reference_run */ 2:
                    message.referenceRun = SimRun.internalBinaryRead(reader, reader.uint32(), options, message.referenceRun);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimRunData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimRun run = 1; */
        if (message.run)
            SimRun.internalBinaryWrite(message.run, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimRun reference_run = 2; */
        if (message.referenceRun)
            SimRun.internalBinaryWrite(message.referenceRun, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimRunData
 */
export const SimRunData = new SimRunData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetailedResultsUpdate$Type extends MessageType<DetailedResultsUpdate> {
    constructor() {
        super("proto.DetailedResultsUpdate", [
            { no: 1, name: "run_data", kind: "message", oneof: "data", T: () => SimRunData },
            { no: 2, name: "settings", kind: "message", oneof: "data", T: () => SimSettings }
        ]);
    }
    create(value?: PartialMessage<DetailedResultsUpdate>): DetailedResultsUpdate {
        const message = { data: { oneofKind: undefined } };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetailedResultsUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetailedResultsUpdate): DetailedResultsUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimRunData run_data */ 1:
                    message.data = {
                        oneofKind: "runData",
                        runData: SimRunData.internalBinaryRead(reader, reader.uint32(), options, (message.data as any).runData)
                    };
                    break;
                case /* proto.SimSettings settings */ 2:
                    message.data = {
                        oneofKind: "settings",
                        settings: SimSettings.internalBinaryRead(reader, reader.uint32(), options, (message.data as any).settings)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetailedResultsUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimRunData run_data = 1; */
        if (message.data.oneofKind === "runData")
            SimRunData.internalBinaryWrite(message.data.runData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimSettings settings = 2; */
        if (message.data.oneofKind === "settings")
            SimSettings.internalBinaryWrite(message.data.settings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DetailedResultsUpdate
 */
export const DetailedResultsUpdate = new DetailedResultsUpdate$Type();
